.trigger {
  display: inline-flex;
  align-items: center;
  gap: var(--space-2);
  height: var(--control-height);
  padding: 0 var(--space-3);
  border: 1px solid transparent;
  border-radius: var(--radius-control);
  background: transparent;
  color: var(--ink);
  font: var(--t-body-strong);
  cursor: pointer;
}

.trigger {
  max-width: 100%;
  transition: background-color var(--dur) var(--ease);
}

/* A long label (a facility name) is cut with an ellipsis instead of pushing the top bar. */
.label {
  min-width: 0;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.caret {
  flex: none;
}

.trigger[data-hovered] {
  background: var(--brand-tint);
}

.trigger[data-pressed] {
  background: var(--brand-tint-strong);
}

.trigger[data-focus-visible] {
  outline: var(--focus-ring);
  outline-offset: var(--focus-offset);
}

/* The account menu: a round avatar with the initials, like a profile picture. */
.trigger[data-variant='avatar'] {
  justify-content: center;
  width: var(--control-height);
  padding: 0;
  border-color: var(--border);
  border-radius: 50%;
  background: var(--wash);
  font: var(--t-small);
  font-weight: 600;
}

/* A small downward chevron drawn with borders, so no icon font is needed. */
.caret {
  width: 6px;
  height: 6px;
  margin-top: -3px;
  border-right: 1.5px solid currentcolor;
  border-bottom: 1.5px solid currentcolor;
  transform: rotate(45deg);
}

.popover {
  min-width: 200px;
  border-radius: var(--radius-float);
  background: var(--paper);
  box-shadow: var(--shadow-float);
}

.popover[data-entering] {
  animation: fade var(--dur) var(--ease);
}

.menu {
  padding: var(--space-1);
  outline: none;
}

.item {
  display: flex;
  align-items: center;
  min-height: var(--row-height);
  padding: 0 var(--space-3);
  border-radius: var(--radius-control);
  font: var(--t-body);
  cursor: pointer;
  outline: none;
}

.item[data-focused] {
  background: var(--brand-tint);
}

.item[data-focus-visible] {
  outline: var(--focus-ring);
  outline-offset: -2px;
}

.item[data-selected] {
  font: var(--t-body-strong);
}

@keyframes fade {
  from {
    opacity: 0;
  }
}
